// extracted by mini-css-extract-plugin
export default {"phtv_header":"index_phtv_header_SCCCs","phtv_nav":"index_phtv_nav_kMFVc","phtv_logo":"index_phtv_logo_oguXt"};